/* biome-ignore-all lint/correctness/useUniqueElementIds: react-intl message ids are not DOM ids in this component. */
import { Button, Flex, Spin } from "antd";
import useGetSignedImageUrl from "hooks/useGetSignedImageUrl";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import useUploadPersonImage from "../hooks/useUploadPersonImage";
import ImageUploader from "./ImageUploader";

import "./UploadImageForm.css";

type Props = {
  personImagePropertyKey: string;
  imageUrl: string | null;
  updatePerson: (data: Record<string, string | null>) => void;
};

const PlaceholderImage = () => (
  <svg aria-hidden="true" focusable="false">
    <line x1="0" y1="100%" x2="100%" y2="0" />
    <line x1="0" y1="0" x2="100%" y2="100%" />
  </svg>
);

const UploadImageForm = ({ personImagePropertyKey, imageUrl, updatePerson }: Props) => {
  const [isImageProcessing, setIsImageProcessing] = useState(false);
  const { mutateAsync: uploadImage } = useUploadPersonImage();
  const { data: signedUrl, isLoading: isSignedUrlLoading } = useGetSignedImageUrl(imageUrl);
  const isLoading = isSignedUrlLoading || isImageProcessing;
  const resolvedImageUrl = signedUrl || imageUrl;

  const handleClear = async () => {
    setIsImageProcessing(true);
    await updatePerson({ [personImagePropertyKey]: null });
    setIsImageProcessing(false);
  };

  const handleDrop = async (file) => {
    setIsImageProcessing(true);
    const filePath = await uploadImage({ file });
    await updatePerson({ [personImagePropertyKey]: filePath });
    setIsImageProcessing(false);
  };

  return (
    <div className="upload-form-wrapper">
      <div className={`image-wrapper${isLoading ? " is-loading" : ""}`}>
        {isLoading && <Spin size="large" className="spinner" />}
        {resolvedImageUrl && !isSignedUrlLoading ? (
          <img alt={personImagePropertyKey} src={resolvedImageUrl} />
        ) : (
          <PlaceholderImage />
        )}
      </div>
      <Flex justify="space-between">
        <ImageUploader handleUpload={handleDrop} disabled={isLoading} />
        <Button onClick={handleClear} disabled={!imageUrl || isLoading}>
          <FormattedMessage id="image.clear" />
        </Button>
      </Flex>
    </div>
  );
};

export default UploadImageForm;
